import { supabase } from "../supabaseClient";

export async function registrarAtividade({ projectId, userId, tipoAcao, entidade, entidadeId, nomeItem }) {
  if (!projectId || !tipoAcao) return;
  try {
    await supabase.from("project_atividades").insert({
      project_id:  projectId,
      user_id:     userId   || null,
      tipo_acao:   tipoAcao,
      entidade:    entidade  || null,
      entidade_id: entidadeId || null,
      nome_item:   nomeItem  || null,
    });
  } catch (err) {
    console.warn("[registrarAtividade]", err);
  }
}